
<f-dialog
    v-if    = "report"
    :title  = "report.name"
    v-model = "value"
    :width  = "460"
    storeLabel="Erstellen"
    @cancel = "onCancel"
    @store  = "onCreate"
>
    <template v-slot:content>
        <div
            v-if="!loading"
            style="height: 6px;"
        ></div>
        <v-progress-linear
            v-if="loading"
            indeterminate
            color  = "primary"
            height = "6"
            class  = "w-100"
        />
        <v-form ref="form" >
            <v-card-text class="pb-0">
                <div class="parameter-list" >
                    <div v-for="(parameter, index) in report.parameter" :key="index">
                        <div v-if = "parameter.type === 'MultiCustomer'">
                            <v-switch
                                label="Meine Kunden"
                                v-model = "myCustomers"
                                class="mb-6 mt-0 pt-0"
                                :ripple = "false"
                                @change = "onMyCustomer"
                                dense
                                hide-details
                            />

                            <v-autocomplete
                                dense
                                chips
                                label="Kunden"
                                multiple
                                deletable-chips
                                hide-no-data
                                return-object
                                auto-select-first
                                :hide-selected = "true"
                                v-model       = "customer"
                                :items        = "limCustomer"
                                :menu-props   = "menuProps"
                                item-value    = "id"
                                item-text     = "name"
                                autocomplete  = "off"
                                autocorrect   = "off"
                                autocapitalize= "off"
                                spellcheck    = "false"
                                append-icon=""
                                small-chips
                                clearable
                                :readonly      = "!!configuration|| myCustomers"
                            >
                                <template v-slot:item="data">
                                    <v-list-item-content>
                                        <v-list-item-title class="component-title" v-html="data.item.name"></v-list-item-title>
                                    </v-list-item-content>
                                </template>
                            </v-autocomplete>
                        </div>

                        <f-enum-autocomplete
                            v-if = "parameter.type === 'Customer'"
                            v-model = "customer"
                            label   = "Kunde"
                            module  = "msd"
                            type    = "limCustomer"
                            class   = "mb-2"
                            clearable
                            :rules  = "[customerRequiredRule]"
                            :readonly      = "!!configuration"
                        />

                        <f-enum-autocomplete
                            v-if = "parameter.type === 'AllCustomer'"
                            v-model = "customer"
                            label   = "Kunde"
                            module  = "msd"
                            type    = "customer"
                            class   = "mb-2"
                            clearable
                            :rules  = "[customerRequiredRule]"
                            :readonly      = "!!configuration"
                        />

                        <f-enum-autocomplete
                            v-if = "parameter.type === 'User'"
                            v-model = "user"
                            label   = "Bearbeiter"
                            module  = "msd"
                            type    = "users"
                            class   = "mb-2"
                            :rules  = "[userRequiredRule]"
                            item-text = "name"
                            :clearable = "true"
                            :disabled      = "!!configuration"
                        />

                        <c-site-select-single
                            v-if = "parameter.type === 'Site'"
                            :customer = "customer"
                            @site     = "onSite"
                        />

                        <div v-if="parameter.type === 'FromDate' || parameter.type === 'OptionalFromDate'">
                            <v-text-field
                                v-model = "fromDate"
                                type           = "date"
                                :label         = "parameter.name"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                :disabled      = "!!configuration"
                            />
                        </div>

                        <div v-if="parameter.type === 'ToDate' || parameter.type === 'OptionalToDate'">
                            <v-text-field
                                v-model        = "toDate"
                                :label         = "parameter.name"
                                type           = "date"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                :disabled      = "!!configuration"
                            />
                        </div>
                        <div v-if="parameter.type === 'LimEnd'">
                            <v-text-field
                                v-model        = "limEnd"
                                :label         = "parameter.name"
                                type           = "date"
                                autocomplete   = "off"
                                autocorrect    = "off"
                                autocapitalize = "off"
                                spellcheck     = "false"
                                :disabled      = "!!configuration"
                                clearable
                            />
                        </div>
                        <div v-if="parameter.type === 'DocType'">
                            <v-select
                                :items         = "doctypes"
                                label          = "Dokumententyp"
                                v-model        = "docType"
                                :disabled      = "!!configuration"
                            />
                        </div>
                        <div v-if="parameter.type === 'Locale'">
                            <v-select
                                :items         = "locales"
                                label          = "Sprache"
                                v-model        = "locale"
                                item-value     = "id"
                                item-text      = "name"
                                :return-object = true
                                :disabled      = "!!configuration"
                            />
                        </div>

                        <div v-if="parameter.type === 'Stored' && report.configurations">
                            <v-select
                                :items         = "report.configurations"
                                label          = "VE"
                                v-model        = "configuration"
                                item-value     = "id"
                                item-text      = "fullname"
                                :return-object = "true"
                                :clearable     = "true"
                                @change        = "onConfiguration"
                            />
                        </div>

                        <div v-if="parameter.type === 'ScheduledZUS'">
                            <v-switch
                                label="Mit geplanten ZÜS Prüfungen"
                                v-model = "scheduled"
                                class="mb-6 mt-0 pt-0"
                                :ripple = "false"
                                dense
                                hide-details
                                :disabled      = "!!configuration"
                            />
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-form>
    </template>

</f-dialog>
